import { useState } from 'react'
import { ChatWindow } from './components/Chat'
import { KanbanBoard } from './components/Kanban'
import { ActivityLog } from './components/Activity'

// ============================================================================
// Types
// ============================================================================

type Tab = 'chat' | 'kanban' | 'activity'

// ============================================================================
// App Component
// ============================================================================

function App() {
  const [activeTab, setActiveTab] = useState<Tab>('chat')
  const [selectedTaskId, setSelectedTaskId] = useState<string | null>(null)

  // ============================================================================
  // Handlers
  // ============================================================================

  const handleTaskCreated = (taskId: string) => {
    console.log('Task created:', taskId)
    setSelectedTaskId(taskId)
  }

  const handleTaskClick = (taskId: string) => {
    console.log('Task clicked:', taskId)
    setSelectedTaskId(taskId)
    // Poderia abrir modal de detalhes aqui
  }

  // ============================================================================
  // Render
  // ============================================================================

  return (
    <div className="flex flex-col h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header/Navigation */}
      <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 shadow-sm">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo/Title */}
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                🤖 Meu Claude 24/7 UI
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Interface AutoClade integrada ao sistema de tasks
              </p>
            </div>

            {/* User Info */}
            <div className="flex items-center gap-3">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Lucas Donha
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  {new Date().toLocaleDateString('pt-BR')}
                </p>
              </div>
              <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold">
                L
              </div>
            </div>
          </div>

          {/* Tabs */}
          <nav className="flex gap-1 mt-4">
            <button
              onClick={() => setActiveTab('chat')}
              className={`px-4 py-2 rounded-t-lg font-medium transition-colors ${
                activeTab === 'chat'
                  ? 'bg-gray-50 dark:bg-gray-900 text-blue-600 dark:text-blue-400 border-t-2 border-blue-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              💬 Chat
            </button>

            <button
              onClick={() => setActiveTab('kanban')}
              className={`px-4 py-2 rounded-t-lg font-medium transition-colors ${
                activeTab === 'kanban'
                  ? 'bg-gray-50 dark:bg-gray-900 text-blue-600 dark:text-blue-400 border-t-2 border-blue-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              📋 Kanban
            </button>

            <button
              onClick={() => setActiveTab('activity')}
              className={`px-4 py-2 rounded-t-lg font-medium transition-colors ${
                activeTab === 'activity'
                  ? 'bg-gray-50 dark:bg-gray-900 text-blue-600 dark:text-blue-400 border-t-2 border-blue-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              📊 Activity
            </button>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-hidden">
        {activeTab === 'chat' && (
          <ChatWindow
            onTaskCreated={handleTaskCreated}
            autoCreateSubtasks={true}
          />
        )}

        {activeTab === 'kanban' && (
          <KanbanBoard
            onTaskClick={handleTaskClick}
            refreshInterval={5000}
          />
        )}

        {activeTab === 'activity' && (
          <ActivityLog
            maxEntries={100}
            autoScroll={true}
            showFilters={true}
          />
        )}
      </main>

      {/* Footer */}
      <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 px-6 py-3">
        <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
          <div>
            <span>Worker 24/7 ativo</span>
            <span className="mx-2">•</span>
            <span>PostgreSQL conectado</span>
            <span className="mx-2">•</span>
            <span>Real-time WebSocket</span>
          </div>

          <div>
            v1.0.0 - {new Date().toLocaleTimeString('pt-BR')}
          </div>
        </div>
      </footer>
    </div>
  )
}

export default App
